import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-session-timeout-dialog",
  templateUrl: "./session-timeout-dialog.component.html",
  styleUrls: ["./session-timeout-dialog.component.scss"]
})
export class SessionTimeoutDialogComponent
{
  private timeoutId: any;
  private readonly autoCloseTime = 30000;

  constructor(public dialogRef: MatDialogRef<SessionTimeoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any)
  {
    this.startTimer();
  }

  startTimer()
  {
    this.timeoutId = setTimeout(() =>
    {
      this.dialogRef.close('auto-closed');
    }, this.autoCloseTime);
  }

  handleYesClick()
  {
    clearTimeout(this.timeoutId);
    this.dialogRef.close(true);
  }

  handleNoClick()
  {
    clearTimeout(this.timeoutId);
    this.dialogRef.close(false);
  }
}
